import './edit-power.scss';
import React from 'react';
import { provideHooks } from 'redial';
import { connect } from 'react-redux';
// actions
import { getOrder } from '../../../actionCreators/order';
import { showGlobalHeaderFooter } from '../../../actionCreators/header';
import { getQueryParam } from '../../../utils/helper';
import sessionStorageHelper from '../../../utils/sessionStorageHelper';
// components
import OrderInfo from './OrderInfo';
import CheckoutHeader from '../../components/Checkout/CheckoutHeader/CheckoutHeader';
import ZeroPower from './ZeroPower';
import ContactLens from './ContactLens';
import PowerGlass from './PowerGlass';
import Accessories from './Accessories';
import ConfirmationModal from './ConfirmationModal';
import getSetCookie from '../../../cookie';
import { Loader, OrderError, sortCallback } from './power-utils';

@provideHooks({
    fetch: ({ store: { dispatch } }) => {
        dispatch(showGlobalHeaderFooter({ header: false, footer: false }));
    },
    defer: ({ location, store: { dispatch } }) => {
        const query = location.search.substr(1);
        const orderId = getQueryParam(query, 'orderId');
        const email = getQueryParam(query, 'email');
        const updatedBy = getQueryParam(query, 'user');
        if (updatedBy) {
            sessionStorageHelper.setItem('updatedBy', updatedBy);
        }
        if (orderId) {
            getSetCookie.setCookie('orderId', orderId);
        }
        dispatch(getOrder({ orderId, email }));
    }
})

class EditPowerContainer extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false
        };
        this.submitCallback = this.submitCallback.bind(this);
        this.hideHandler = this.hideHandler.bind(this);
        this.source = getQueryParam(props.location.search, 'source') || null;
    }

    getClassifiedItems(items) {
        const res = { contactLens: [], powerGlass: [], zeroPower: [], accessories: [] };
        if (items == null) return res;
        const r = items.reduce((memo, item) => {
            if (item.powerRequired !== 'POWER_NOT_REQUIRED') {
                if (item.classification === 'contact_lens') memo.contactLens.push(item);
                else memo.powerGlass.push(item);
            } else if (item.lensType === 'ZERO_POWER') memo.zeroPower.push(item);
            else memo.accessories.push(item);
            return memo;
        }, res);
        r.contactLens.sort(sortCallback);
        r.powerGlass.sort(sortCallback);
        r.zeroPower.sort(sortCallback);
        r.accessories.sort(sortCallback);
        return r;
    }

    submitCallback(submitValues, item, changedPackage) {
        this.submitValues = submitValues;
        this.submitItem = item;
        this.changedPackage = changedPackage;
        this.setState({ showModal: true });
    }

    hideHandler() {
        this.setState({ showModal: false });
    }

    render() {
        const { showModal } = this.state;
        const { order = {}, loading, dataLocale } = this.props;
        const { items = [], id, billingAddress = {} } = order;
        const { contactLens = [], powerGlass = [], zeroPower = [], accessories = [] } = this.getClassifiedItems(items);
        const orderLoading = loading || __SERVER__;
        return (
            <div className="cs-edit-power">
                <CheckoutHeader logo="https://static.lenskart.com/media/desktop/img/checkout_Lenskart_logo_2x.png" />
                {orderLoading && <div style={{ paddingTop: '20%' }}><Loader /></div>}
                {!orderLoading && (order.id ? (<div className="update-power-container">
                    <OrderInfo id={id} billingAddress={billingAddress} dataLocale={dataLocale} />
                    <hr className="margin-t10 margin-b10" />
                    <div className="padding-t15 padding-b15">
                        {powerGlass && powerGlass.length > 0 && powerGlass.map(d => <React.Fragment key={d.id}><PowerGlass item={d} submitCallback={this.submitCallback} /><hr className="margin-t10 margin-b10" /></React.Fragment>)}
                        {contactLens && contactLens.length > 0 && contactLens.map(d => <React.Fragment key={d.id}><ContactLens item={d} submitCallback={this.submitCallback} /><hr className="margin-t10 margin-b10" /></React.Fragment>)}
                        {zeroPower && zeroPower.length > 0 && zeroPower.map(d => <React.Fragment key={d.id}><ZeroPower item={d} submitCallback={this.submitCallback} /><hr className="margin-t10 margin-b10" /></React.Fragment>)}
                        {accessories && accessories.length > 0 && accessories.map(d => <React.Fragment key={d.id}><Accessories dataLocale={dataLocale} item={d} submitCallback={this.submitCallback} /><hr className="margin-t10 margin-b10" /></React.Fragment>)}
                    </div>
                </div>) : <div style={{ paddingTop: '20%' }}><OrderError /></div>)}
                {showModal && <ConfirmationModal source={this.source} showModal={showModal} hideHandler={this.hideHandler} values={this.submitValues} item={this.submitItem} changedPackage={this.changedPackage} />}
            </div>
        );
    }
}

function mapStateToProps(state) {
    const order = state.order.orderDetails ? state.order.orderDetails.result : undefined;
    return {
        order,
        loading: state.order.loading,
        dataLocale: state.locale
    };
}

export default connect(mapStateToProps)(EditPowerContainer);
